/* eslint-disable */
import axios from '@/services/axios'

export default {
    listBrand(search, source) {
        return axios.post("/insight/getBrands", search, { cancelToken: source.token });
    },
    listFirstClass(search, source) {
        return axios.get("/insight/getFirstClasses", { params: search, cancelToken: source.token });
    },
    getMiddleClasslist(search, source) {
        return axios.post("/insight/getMiddleClasses", search, { cancelToken: source.token });
    },
    getInsightDataCDJTable(search, source) {
        return axios.post("/insight/getInsightDataCDJTable", search, { cancelToken: source.token });
    },
    getInsightDataCDJTable2(search, source) {
        return axios.post("/insight/getInsightDataCDJTable2", search, { cancelToken: source.token });
    },
    getInsightDataDonutBar(search, source) {
        return axios.post("/insight/getInsightDataDonutBar", search, { cancelToken: source.token });
    },
    getInsightDataUpperTable(search, source) {
        return axios.post("/insight/getInsightDataUpperTable", search, { cancelToken: source.token });
    },
    getInsightDataUpperTableExp(search, source) {
        return axios.post("/insight/getInsightDataUpperTableExp", search, { cancelToken: source.token });
    },
    getInsightDataStacked(search, source) {
        return axios.post("/insight/getInsightDataStacked", search, { cancelToken: source.token });
    },
    getInsightDataStackedMerge(search, source) {
        return axios.post("/insight/getInsightDataStackedMerge", search, { cancelToken: source.token });
    },
    getInsightDataBottomTable(search, source) {
        return axios.post("/insight/getInsightDataBottomTable", search, { cancelToken: source.token });
    },
    getInsightDataBottomTableETC(search, source) {
        return axios.post("/insight/getInsightDataBottomTableETC", search, { cancelToken: source.token });
    },
    getInsightDataBottomTableETCETC(search, source) {
        return axios.post("/insight/getInsightDataBottomTableETCETC", search, { cancelToken: source.token });
    },
    getMapHistory(search, source) {
        return axios.post("/insight/getMapHistory", search, { cancelToken: source.token });
    },
    getInsightDataBrandMap(search, source) {
        return axios.post("/insight/getInsightDataBrandMap", search, { cancelToken: source.token });
    },
    getInsightDataBrandMapETC(search, source) {
        return axios.post("/insight/getInsightDataBrandMapETC", search, { cancelToken: source.token });
    },
    getInsightDataBrandMapETCETC(search, source) {
        return axios.post("/insight/getInsightDataBrandMapETCETC", search, { cancelToken: source.token });
    },
    getInsightDataDetailMap(search, source) {
        return axios.post("/insight/getInsightDataDetailMap", search, { cancelToken: source.token });
    },
    getInsightDataDetailMapETC(search, source) {
        return axios.post("/insight/getInsightDataDetailMapETC", search, { cancelToken: source.token });
    },
    getInsightDataLineBrand(search, source) {
        return axios.post("/insight/getInsightDataLineBrand", search, { cancelToken: source.token });
    },
    getInsightDataLineDetail(search, source) {
        return axios.post("/insight/getInsightDataLineDetail", search, { cancelToken: source.token });
    },
    getInsightDataLineBrandETC(search, source) {
        return axios.post("/insight/getInsightDataLineBrandETC", search, { cancelToken: source.token });
    },
    getInsightDataLineDetailETC(search, source) {
        return axios.post("/insight/getInsightDataLineDetailETC", search, { cancelToken: source.token });
    },
    getInsightDataLineBrandETCETC(search, source) {
        return axios.post("/insight/getInsightDataLineBrandETCETC", search, { cancelToken: source.token });
    },
    getInsightDataLineDetailETCETC(search, source) {
        return axios.post("/insight/getInsightDataLineDetailETCETC", search, { cancelToken: source.token });
    },
};
